/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
* Note - Only extending AbstractService to get the download function...
*/
import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { AbstractObject } from "@src/app/model/abstract-object";
import { AbstractHttpService } from "@src/app/shared/abstract-http.service";
import { MessageService } from "@src/app/shared/message.service";
import { TemplateParams } from "@src/app/modules/importer/import-page/download-template-action";

@Injectable({
    providedIn: 'root'
})
export class XeroService extends AbstractHttpService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);

    protected get baseUrl(): string {
        return ;
    }
    protected cache: AbstractObject[];
    protected typeString = 'Xero Server Communication';

    getTemplate(parms?: Partial<TemplateParams>) {
        this.http.post('/xeroApi/templateXls', parms ?? {}, {
            headers: { 'Accept': 'application/octet-stream' },
            observe: 'response',
            responseType: 'blob'
        }).subscribe({
            next: response => {
                this.doResponseDownload(response);
                this.messageService.show('Template successfully downloaded, check your downloads folder');
            },
            error: err => this.handleOneError('Downloading Template', null)(err)
        });
    }
}